import EocMedicationsV1 from "../../../../components/form_builder/elements/eoc_medications/EocMedicationsV1.vue";

export default {
  componentName: "fb-eoc-medications-v1",
  component: EocMedicationsV1,
  defaultAttrs: {
    properties: {
      value: ``,
      style: {},
      label: "Patient Medications",
      description: "",
      eFormEditable: true,
      hidden: false
    }
  },
  gridAttrs: {
    type: "template",
    hidden: true,
    template: ({ value }) => value
  },
  validate: () => {
    return [];
  }
};
